import { uuid } from '@utils/common';

import { TAssetTypeSubTypeItem } from '@interfaces/assets/asset';
import { IAssetTypeForFilter } from '@interfaces/map/mapFilters';

export function transformAssetTypes(assetTypes: Array<TAssetTypeSubTypeItem>): IAssetTypeForFilter[] {
	return assetTypes.map((asset) => {
		const transformedAssetType: IAssetTypeForFilter = {
			name: asset.type.assetTypeName,
			iconURL: asset?.type?.icon?.downloadUrl,
			isSelected: false,
			id: asset.type.id,
			type: asset.type.assetTypeName.toUpperCase().replace(/\s+/g, '_'),
		};

		if (asset.subTypes && asset.subTypes.length > 0) {
			transformedAssetType.isItemsOpen = false;
			transformedAssetType.subTypes = [
				{
					name: asset.type.assetTypeName,
					isSelected: false,
					subType: 'NO_SUBTYPE',
					id: uuid(),
				},
				...asset.subTypes.map((subType) => ({
					name: subType.assetSubTypeName,
					isSelected: false,
					id: subType.id,
					subType: subType.assetSubTypeName.toUpperCase().replace(/\s+/g, '_'),
				})),
			];
		}

		return transformedAssetType;
	});
}
